// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { AggregateGroupWrapper } from './styles'
import HeadingRow from './HeadingRow'
import AggregateRow from './AggregateRow'
import MatchRow from './MatchRow'

const AggregateGroup = ({ groupData, idRoot, nameRoot }) => {
  // this group will have a 'select all' checkbox at the top and
  // a checkbox for each individual match row for this aggregate.
  // this name is the redux-form field name that all these checkboxes will point to.

  // The two different types of boxes described above behave differently in their
  // on change handlers but are both manipulating this same value.
  const checkboxGroupName = `${nameRoot}matchedSegmentEndIds`

  return (
    <AggregateGroupWrapper className={'width-100'}>
      <thead className={'bg-blue-dark'}>
        <HeadingRow
          idRoot={`${idRoot}-heading-row`} />
        <AggregateRow
          aggregateGroupMatches={groupData.matches}
          checkboxGroupName={checkboxGroupName}
          idRoot={`${idRoot}-callSignCascadeAggregateSegmentEnd`}
          segmentEndData={groupData.callSignCascadeAggregateSegmentEnd} />
      </thead>
      <tbody>
        {
          groupData.matches.map((d, i) => (
            <MatchRow
              key={d.segmentEndId}
              checkboxGroupName={checkboxGroupName}
              idRoot={`${idRoot}-${d.segmentEndId}`}
              rowIndex={i}
              segmentEndData={d} />
          ))
        }
      </tbody>
    </AggregateGroupWrapper>
  )
}

AggregateGroup.propTypes = {
  groupData: object.isRequired,
  idRoot: string.isRequired,
  nameRoot: string.isRequired,
}

export default AggregateGroup
